import { PrivacyView } from 'src/sections/privacy/privacy-view';

export default function PrivacyPage() {
  return <PrivacyView />;
}
